import React from "react"

type Props = any
type State = any

// Could be a general error page
export class ErrorBoundaryWithRetry extends React.Component<Props, State> {
  state = { error: null }

  static getDerivedStateFromError(error: any): State {
    return { error }
  }

  _retry = () => {
    // This ends up calling loadQuery again to get and render
    // a new query reference
    // this.props.onRetry()
    this.setState({
      // Clear the error
      error: null,
    })
  }

  render() {
    const { children, fallback } = this.props
    const { error } = this.state
    if (error) {
      if (typeof fallback === "function") {
        return fallback(error, this._retry)
      }
      return fallback
    }
    return children
  }
}
